<template>
  <div id="app">
    <div v-if="ishow"
      style="position:fixed;z-index:10000;top:0;width:100px;margin-left:-50px;left:50%;background-color:#ffb734;text-align:center;padding:10px;border-radius:0 0 4px 4px;opacity:.5;font-weight:bold;pointer-events:none;">
      测试环境</div>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>

export default {
  name: 'App',
  data() {
    return {
      ishow: true
    }
  },
  created() {

    let _this = this
    // 系统判断
    if (window.location.host == 'xz.giant.com.cn') { 
      _this.ishow = false
    } else {
      _this.ishow = true
    }
  },
  methods: {

  }
}
</script>

<style>
.el-message-box .el-message-box__btns .el-button{
  border-radius: 25px !important;
}

.el-button--primary {
  background: #4E66FF !important;
  color: #FFF !important;
}

.el-button--primary:hover {
  background: #4E66FF !important;
  border-color: #4E66FF !important;
  color: #FFF !important;
}


.el-carousel__indicators--horizontal{
  display: none;
}

.el-table{
  color: #383838 !important;
}
.el-table .el-checkbox__inner {
  border-radius: 25px !important;
  width: 16px !important;
  height: 16px !important;
}

.el-table .el-checkbox__inner::after {
  height: 6px !important;
  left: 5px !important;
  top: 2px !important;
}

.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner::before {
  top: 6px !important;
}

.el-table .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #4E66FF !important;
  border-color: #4E66FF !important;
}


.el-dialog {
  position: fixed !important;
  margin: 0 auto 50px;
  background: #FFF;
  box-shadow: 0 1px 3px rgba(0, 0, 0, .3);
  box-sizing: border-box;
  top: 35% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
}

/* 
.el-dialog .el-dialog__body {
  flex: 1;
  overflow: auto;
  padding: 20px;
  display: flex;
  justify-content: center;
} */

.el-dialog__body{
  padding:15px 20px !important;
  overflow: hidden;
}

.el-input__inner {
  border-radius: 30px !important;
}


.el-image-viewer__canvas img{
    width: initial;
}
</style>

<style lang="less" scoped>
#app {
  height: 100%;
}
</style>
